import * as React from 'react';
import {Rate} from 'antd';
class Ratecomponent extends React.Component {
  render () {
    return <Rate allowHalf defaultValue={2.5} />;
  }
}

export default Ratecomponent;
